/** tenant_configuration_option codes (must match API ConfigurationOptionCodeEnum). */
export const DONOR_PORTAL_SCREEN_CONFIG_CODE = {
  DONATE_NEAR_YOU_SEARCH: 'DP_DONATE_NEAR_YOU_SEARCH',
  DONATE_NEAR_YOU_RESULTS: 'DP_DONATE_NEAR_YOU_RESULTS',
  SEARCH_BY_DONOR_CENTERS_SEARCH: 'DP_SEARCH_BY_DONOR_CENTERS_SEARCH',
  SEARCH_BY_DONOR_CENTERS_RESULTS: 'DP_SEARCH_BY_DONOR_CENTERS_RESULTS',
  SEARCH_BY_ZIP_CODE_SEARCH: 'DP_SEARCH_BY_ZIP_CODE_SEARCH',
  SEARCH_BY_ZIP_CODE_RESULTS: 'DP_SEARCH_BY_ZIP_CODE_RESULTS',
  SEARCH_BY_CITY_SEARCH: 'DP_SEARCH_BY_CITY_SEARCH',
  SEARCH_BY_CITY_RESULTS: 'DP_SEARCH_BY_CITY_RESULTS',
  SEARCH_BY_SPONSOR_SEARCH: 'DP_SEARCH_BY_SPONSOR_SEARCH',
  SEARCH_BY_SPONSOR_RESULTS: 'DP_SEARCH_BY_SPONSOR_RESULTS',
  APPOINTMENT_SCHEDULING: 'DP_APPOINTMENT_SCHEDULING',
  BADGES_BANNER_HEADING: 'DP_BADGES_BANNER_HEADING',
  BADGES_BANNER_MESSAGE: 'DP_BADGES_BANNER_MESSAGE',
}
